<template>
  <div class="left-zhu">
    <!-- <div class="header-top" @click="$router.push('/profile/userInfo')"> -->
    <!--<div class="header-top">-->
    <!--<p class="header-logo"><img src="@/assets/images/tianyitang01.png"></p>-->
    <!-- <p class="header-tou"><img src="https://meton.vip/api_store/upload/store/touxiang/1626492768654.jpg"></p>  -->
    <!-- <p class="header-xin"><span>{{ userName }} &nbsp {{ roleName}}</span> </p> -->
    <!--</div>-->
    <!--<div class="header-title">标题</div>-->
    <scroll-bar>
      <el-menu :collapse="isCollapse" :default-active="$route.path" :show-timeout="200" active-text-color="#409EFF"
               background-color="#304156" class="topheader" mode="vertical" text-color="#bfcbd9" unique-opened>
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </scroll-bar>
    <!-- <div class="bottom-logo"> -->
    <!-- <div style="margin-top:20px">jinbai系统</div>  -->
    <!-- <div>版本：v1.0</div> -->
    <!-- </div>-->
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: {SidebarItem, ScrollBar},
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data() {
    return {
      userName: 'Zhwg',
      roleName: '店长'
    }
  }
}
</script>
<style lang="scss" scoped>
.left-zhu {
  position: relative;
}

.header-top {
  // height: 120px;
  text-align: center;
  background-color: white;
  cursor: pointer;
  padding-bottom: 15px;

  .header-tou {
    margin: top 5px;

    img {
      width: 100px;
      height: 100px;
      border-radius: 10px;
    }
  }

  .header-logo img {
    margin-top: 20px;
    width: 180px;
    height: auto;
  }

  .header-xin {
    span {
      margin-right: 10px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
    }
  }
}

.header-title {
  width: 100%;
  height: 66px;
  background-color: #304156;
  color: #333;
  font-size: 24px;
  text-align: center;
  font-weight: 600;
}

// .topheader{
//   overflow: auto;
// }
.bottom-logo {
  width: 100%;
  min-height: 60px;

  div {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #aebac9;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue